<template>

  <div>

    <!-- barra superior y botonera de acciones -->
    <v-card>
      <v-toolbar color="white " flat>
        <v-btn icon light>
          <v-icon color="grey darken-2 ">list</v-icon>
        </v-btn>
        <v-toolbar-title class="grey--text text--darken-4 ">
          {{ $t('articulos') }}
          <p class="caption ">{{ $t('lineasPresupuesto') }}</p>
        </v-toolbar-title>
        <div v-show="dShowLoading" id="loading" style="margin-left:50px;margin-top:-10px;z-index:99999">
          <div style="display: inline-block;">
            <cube-spin class="loadingStyle"></cube-spin>
          </div>
          <div style="display: inline-block;color:#43a047;margin-left:10px;margin-top:-50px">
            <span class="caption">{{ $t('procesando') }}...</span>
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1  white--text" value="volver " @click="fVolver()">
          <v-icon>mdi-arrow-left</v-icon>
          <span>{{ $t('volver') }}</span>
        </v-btn>
        <v-btn color="green darken-1  white--text" value="buscar " @click="fBuscar()">
          <v-icon>mdi-plus</v-icon>
          <span>{{ $t('articulosDesc') }}</span>
        </v-btn>
        <v-btn color="green darken-1  white--text" value="continuar " @click="fGuardaContinuar()">
          <span>{{ $t('continuar') }}</span>
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- tabla de edición de lineas -->
      <EditDataTablePres ref="EditTablePres" @alert="fAlert" @update="fActualizarPresupuestos" @delete="fDeleteLinea"
        :headers="dHeadersLineas" :lineas="dLineas" :itemsAgrupacion="dItemsTodasAgrupaciones"
        :itemsDescuento="dItemsDescuentosLinea" :fechaPedido="dPresupuestoAsistentePaso3.fechaCreacion"
        :moneda="dPresupuestoAsistentePaso3.moneda" :itemsTarifa="dItemsTarifa"></EditDataTablePres>

    </v-card>

    <!-- Dialogo para seleccionar los productos -->
    <v-dialog v-model="dMostrarDialogoBuscador" overlay="false" scrollable max-width="900px">
      <ShpBuscador @loading="fLoading" ref="BuscadorArticulos" @add="fAddItem" @close="fCloseBuscador" @alert="fAlert">
      </ShpBuscador>
    </v-dialog>

    <!-- dialogo para el borrado de lineas -->
    <v-dialog v-model="dMostrarAlertaBorrado" persistent max-width="370">
      <v-card>
        <v-card-title class="subheading" style="text-align: center; padding: 25px 15px">{{
          $t('checkBorradoLineaPresupuestos') }}</v-card-title>
        <v-card-actions style="background-color: #eee;padding: 15px">
          <v-spacer></v-spacer>
          <v-btn color="green darken-1  white--text" @click="dMostrarAlertaBorrado = false">{{ $t('no') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1  white--text" @click="fDeleteLinea(); dMostrarAlertaBorrado = false">{{ $t('si')
            }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>

</template>

<script>

import ShpBuscador from './ShpBuscador'
import ShpAgrupaciones from './ShpAgrupaciones'
import EditDataTablePres from '@/components_datadec/EditDataTablePres'
import DataTable from '@/components_datadec/DataTable'
import CubeSpin from 'vue-loading-spinner/src/components/Jumper'

// SERVICES
import SrvPres from '@/services/srv-presupuestos'

export default {
  name: 'ShpAsistentePaso3',
  props: {
    pPresupuestoAsistente: {
      type: Object,
      required: true
    },
    pEsNuevo: {
      type: Boolean,
      required: true
    }
  },
  components: {
    EditDataTablePres,
    ShpBuscador,
    ShpAgrupaciones,
    DataTable,
    CubeSpin
  },
  data() {
    return {
      dItemDelete: null,
      dShowLoading: !this.pEsNuevo,
      dPresupuestoAsistentePaso3: this.pPresupuestoAsistente,
      dMostrarDialogoBuscador: false,
      dMostrarDialogoAgrupaciones: false,
      dLineas: [],
      dHeadersLineas: [
        { sortable: false },
        { text: this.$t('linea'), value: 'numeroItem', align: 'left' },
        { text: this.$t('producto'), value: 'nombreArticulo', align: 'left' },
        { text: this.$t('agrupacion'), value: 'agrupacion', align: 'left' },
        { text: this.$t('cantidadUMP'), value: 'cantidad', align: 'right' },
        { text: this.$t('cantidadUMV'), value: 'cantidad', align: 'right' },
        { text: 'm3', value: 'm3', align: 'right' },
        { text: this.$t('precio'), value: 'precioArticulo', align: 'right' },
        { text: this.$t('dto'), value: 'tipoDescuentoLinea', align: 'right' },
        { text: this.$t('precioNeto'), value: 'precioArticulo', align: 'right' },
        { text: this.$t('importe'), value: 'importe', align: 'right' },
        { delete: false }
      ],
      dItemsTodasAgrupaciones: [],
      dItemsTarifa: [],
      dItemsDescuentosLinea: [],
      dMostrarAlertaBorrado: false
    }
  },
  methods: {
    fGuardaContinuar() {
      // chequeo de campos y avance
      this.$emit('save', this.dPresupuestoAsistentePaso3)
    },
    fVolver() {
      this.$emit('return')
    },
    fClose() {
      this.dShowLoading = false
    },
    fCloseBuscador() {
      this.dMostrarDialogoBuscador = false
    },
    fCloseAgrupaciones() {
      this.dMostrarDialogoAgrupaciones = false
    },
    fBuscar() {
      // Abre la pantalla buscador de lineas
      this.dMostrarDialogoBuscador = true
      this.$refs.BuscadorArticulos.fEventCargarArticulos(this.dPresupuestoAsistentePaso3.empresa, this.dPresupuestoAsistentePaso3.cliente, this.dPresupuestoAsistentePaso3.sucursal)
    },
    fAlert(msg) {
      this.$emit('alert', msg)
    },
    fAddItem(items) {
      this.dLineas = []
      this.dPresupuestoAsistentePaso3.lineas = []
      this.dShowLoading = true
      this.dMostrarDialogoBuscador = false
      if (items !== null) {
        for (let i = 0; i < items.length; i++) {
          const item = items[i]
          item.agrupacion = 0
          item.nombreAgrupacion = this.$t('sinAgrupacion')
          item.accion = 'I'
          item.precioArticulo = null
          this.dPresupuestoAsistentePaso3.lineas.push(item)
        }
        this.$emit('saveDet', this.dPresupuestoAsistentePaso3)
        this.fCargarDefault(this.dPresupuestoAsistentePaso3)
      }
    },
    fActualizarPresupuestos(linea) {
      this.dPresupuestoAsistentePaso3.lineas = []
      this.dPresupuestoAsistentePaso3.lineas.push(linea)
      this.$emit('saveDet', this.dPresupuestoAsistentePaso3)
    },
    fCargarDefault(presupuesto) {
      this.dShowLoading = true
      this.dPresupuestoAsistentePaso3 = presupuesto
      this.dLineas = presupuesto.lineas.slice()
      this.dShowLoading = false
      this.fCargaTodasAgrupaciones()
      this.fCargaDescuentosLinea()
      this.$refs.EditTablePres.fCargarLineas(this.dLineas)
    },
    /**
     * Borra uan liena del pedido y actualiza el objeto
     */
    fDeleteLinea(item) {
      this.dItemDelete = item
      this.$emit('delete', this.dItemDelete)
    },
    fLoading(msg) {
      this.$emit('loading', msg)
    },
    /**
     * Carga todas las agrupaciones
     */
    fCargaTodasAgrupaciones() {
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        agrupaEmpresa: this.$store.getters.getAutenticacion.empresa
      };
      SrvPres.getAgrupaciones(payload).then(response => {
        if (response.data.statusCode === '200') {
          const dataAgrupaciones = response.data
          this.dItemsTodasAgrupaciones = dataAgrupaciones.AGRUPACIONES
          this.dItemsTodasAgrupaciones.push({ 'agrupaEmpresa': this.$store.getters.getAutenticacion.empresa, 'agrupaCodigo': 0, 'agrupaDenominacion': this.$t('sinAgrupacion') })
        } else {
          this.$emit('alert', '<b>obtiene las agrupaciones</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
      }).catch(error => {
        this.fErrorComprobado(error)
      })
    },
    /**
     * Carga todas los descuentos
     */
    fCargaDescuentosLinea() {
      this.$emit('loading', '')
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        fechaAplicacion: this.$moment(this.pPresupuestoAsistente.fechaCreacion, 'YYYY-MM-DD').format('DD/MM/YYYY'),
        tipoDescuento: 'LIN'
      }
      SrvPres.getListaDtos(payload).then(response => {
        if (response.data.statusCode === '200') {
          this.dItemsDescuentosLinea = response.data.DTOS
        } else {
          this.$emit('alert', '<b>obtiene los descuentos</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
        this.$emit('loading', '')
      }).catch(error => {
        this.fErrorComprobado(error)
        this.$emit('loading', '')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.buttonCellDatatable .btn__content {
  padding: 0 16px 0px 0px !important;
}

.paddingDatatable .container {
  padding: 0px !important;
}

.buttonAcciones {
  height: 40px !important;
}

.buttonAccionesContainer .list__tile {
  padding: 0px !important;
}

.loadingStyle.spinner>div[data-v-def4b4ac] {
  background-color: #43a047 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Informes/Presupuestos/ShpAsistentePaso3.vue